/** Best-effort role names from JWT payload (client UI only). */
export function getRoleNamesFromToken(token: string | null): string[] {
  if (!token) return [];
  try {
    const payload = token.split(".")[1];
    if (!payload) return [];
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const o = JSON.parse(json) as Record<string, unknown>;
    const roleClaim =
      o["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    if (typeof roleClaim === "string" && roleClaim) return [roleClaim];
    if (Array.isArray(roleClaim))
      return roleClaim.filter((x): x is string => typeof x === "string");
    const role = o["role"];
    if (typeof role === "string" && role) return [role];
    if (Array.isArray(role))
      return role.filter((x): x is string => typeof x === "string");
  } catch {
    return [];
  }
  return [];
}

/** Admin login stores the username in the JWT `unique_name` claim. */
export function getUserNameFromToken(token: string | null): string {
  if (!token) return "";
  try {
    const payload = token.split(".")[1];
    if (!payload) return "";
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const o = JSON.parse(json) as Record<string, unknown>;
    const name =
      o.unique_name ??
      o["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"];
    return typeof name === "string" ? name.trim() : "";
  } catch {
    return "";
  }
}

export function tokenHasAnyRole(token: string | null, roles: string[]): boolean {
  if (!roles.length) return false;
  const have = new Set(
    getRoleNamesFromToken(token).map((r) => r.toLowerCase())
  );
  return roles.some((r) => have.has(r.toLowerCase()));
}
